import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const TaxTable = ({title, data, hover, calcResult}) => {

    // convert plain number format into US currency format
    const curFormat = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    // Hold data types in array for formatting our cells
    const typeArr = [];
    data.types.map((type) => {
        return typeArr.push(type);
    });

    if(navigator.maxTouchPoints > 0) {
        hover = 'nohighlight'
    }

    const copyOption = hover === 'Cell' ? 'td:hover' :
        hover === 'Row' ? 'tr:hover' :
        hover === 'Table' ? 'table:hover' : 'tr:hover';

    const copyToClipboard = () => {
        // queryselect hovered table row
        const holdData = document.querySelector(copyOption);

        let range, sel;

        // check if range and selection are supported by the browser
        if(navigator.maxTouchPoints === 0){
            if (document.createRange && window.getSelection) {
                range = document.createRange();
                sel = window.getSelection();

                // unselect any element in the page
                sel.removeAllRanges();

                range.selectNodeContents(holdData);
                sel.addRange(range);

                // write selection to clipboard
                navigator.clipboard.writeText(sel);
            }
            sel.removeAllRanges();
        }
    }

    const findIdx = data.data.map((data) => { return data }).findIndex(({4: n}) => { return n == calcResult; });

    return (
        <TaxTableStyled className='TaxTable'>
            <h3><strong>{title}</strong></h3>
            <p className={ title === undefined ? 'hidden' : 'visible' }>If taxable income is:</p>
            <div className='table-responsive-sm'>
                <table onClick={ copyToClipboard } className={`table table-bordered ${ hover }`}>
                    <thead>
                        <tr key='header'>
                            {
                                data.column_headers.map((data, idx) => {
                                    return <th key={ idx }>{data}</th>
                                })
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            // Map cell data into rows and cells
                            data.data.map((cellData, idx) => {
                                const rowName = 'rightBracket'
                                if(findIdx === idx){
                                    return <tr key={idx} className={ rowName }>{
                                        // Format each cell based on data type
                                        cellData.map((data, idx) => {
                                            typeArr[idx] === "currency" && curFormat.format(data) !== '$NaN' ?  data = curFormat.format(data) :
                                            typeArr[idx] === "string" ? data = data.toUpperCase() :
                                            typeArr[idx] === "percent" ? data = data + "%" : data;
                                            return <td key={idx}>{data}</td>
                                        })
                                    }</tr>
                                }else{
                                    return <tr key={idx} className={ idx }>{
                                        // Format each cell based on data type
                                        cellData.map((data, idx) => {
                                            typeArr[idx] === "currency" && curFormat.format(data) !== '$NaN' ?  data = curFormat.format(data) :
                                            typeArr[idx] === "string" ? data = data.toUpperCase() :
                                            typeArr[idx] === "percent" ? data = data + "%" : data;
                                            return <td key={idx}>{data}</td>
                                        })
                                    }</tr>
                                }
                            })
                        }
                    </tbody>
                </table>
            </div>
        </TaxTableStyled>
    );
}

export default TaxTable;

const TaxTableStyled = styled.div`
    .hidden {
        display: none;
    }

    th:nth-child(-n + 5), td:nth-child(-n + 5) {
        border-right: 1px solid #ddd;
    }

    tr {
        border-bottom: 1px solid #ddd;
        :last-child{
            border-bottom: none;
        }
    }

    tr:nth-child(even) td {
        background-color: #f2f2f2;
    }

    tr:nth-child(even) td:first-child {
        background-color: #f2f2f2;
    }

    tr:nth-child(odd) td:first-child {
        background-color: white;
    }

    .table th:first-child, .table td:first-child {
        position: sticky;
        left: 0px;
    }

    .table.Cell {
        td:hover {
            background-color: #e6f3fb ;
        }
    }

    .table.Row {
            tr:hover td {
            background-color: #e6f3fb;
        }
    }

    .table.Table {
        tbody:hover td {
            background-color: #e6f3fb;
        }
    }
`;